export interface CloudAppListTypes {
  [x: string]: CloudAppType
}

export interface CACAssignment {
  users: string[]
  groups: string[]
}

export type CACAssignments = Record<string, CACAssignment | 'all'>

export interface CloudAppType {
  displayName: string
  is_enabled: boolean
  blockPage: string
  prefix: string
  postfix: string
  columnName: string
  descriptionTitle: string
  subTitle: string
  consumerAccountText?: string
  // TODO (@aman-ds): Remove this after BE contraction.
  consumer_info?: CloudAppConsumerInfo
  additional_controls: CloudAppAdditionalControls
  assignments: CACAssignments
}

export type CloudAppSaveApp = CloudAppType

export type CloudAppSaveList = Record<string, CloudAppSaveApp>

export type CacEntryInputKind = 'domain' | 'id'

export interface CloudAppOptionType {
  displayName: string
  prefix: string
  postfix: string
  columnName: string
  entryInputKind: CacEntryInputKind
  descriptionTitle: string
  hidePrefix?: boolean
  enabledStateTitleForReadAccess?: string
  enableStateTitleForReadAccess?: string
  notEnableStateTitleForReadAccess: string
  notEnableStateTitle: string
  subTitle: string
  consumerAccountText?: string
  additionalInfo?: string
}

// TODO (@aman-ds): Remove this after BE contraction.
export interface CloudAppConsumerInfo {
  login_allowed: boolean
  upload_allowed?: boolean
}

export enum CACRestriction {
  Allow = 'ALLOW',
  Block = 'BLOCK',
  Warning = 'WARNING',
}

export interface CloudAppAdditionalControls {
  consumer_login_allowed: boolean
  consumer_upload_allowed: boolean
  gemini_restriction?: CACRestriction
  copilot_restriction?: CACRestriction
  /**
   * Personal Gemini/Copilot. Google and O365 only; must be false when consumer
   * login or the AI restriction is blocked.
   * https://github.com/dopesecurity/cloud-schemas/pull/394
   */
  consumer_ai_allowed?: boolean
  ssh_over_https_allowed?: boolean
}

export interface CloudAppResponseType {
  inheritsCAC: boolean
  cac: CloudAppListTypes
}

export interface CloudAppPayloadType {
  policyName: string
  cac: CloudAppListTypes | CloudAppSaveList | string
}

export interface CACService {
  displayName: string
  allowedUrls: string[]
  customDomains: string[]
  isEnabled: boolean
}

export interface CACServices {
  box: CACService
  chatgpt: CACService
  claude: CACService
  dropbox: CACService
  github: CACService
  google: CACService
  o365: CACService
  salesforce: CACService
  slack: CACService
  webex: CACService
}

export interface CACBypassMatch {
  domain: string
  matchedInBypass: string
  source: 'custom' | 'default'
}
